<template>
  <div class="comment-bar-layout">
    <ym-tabbar v-if="showBar"
               class="comment-bar"
               :class="{ 'ym-in-app': isAppWebView }"
               :z-index="2"
    >
      <form class="comment-form">
        <ym-field class="comment-input"
                  v-model="content"
                  model="small-round"
                  v-focus.lazy="focus"
                  :placeholder="placeholder"
        >
          <template #button>
            <ym-button class="comment-btn"
                       type="primary"
                       round
                       :disabled="disabled"
                       @click.prevent="handleSendComment"
            >
              发送
            </ym-button>
          </template>
        </ym-field>
      </form>
    </ym-tabbar>
    <div class="page-content"
         @click="handleClickPageContent"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { Tabbar, Field, Button } from '@ymba/ym-ui';
  import validator from '@/utils/validator';
  import { isAppWebView } from '@/utils';

  export default {
    name: 'CommentBarLayout',
    components: {
      'ym-button': Button,
      'ym-field': Field,
      'ym-tabbar': Tabbar,
    },
    data() {
      return {
        content: '',
        disabled: true,
        isAppWebView: isAppWebView(),
      };
    },
    props: {
      showBar: {
        type: Boolean,
        required: true,
        default: false,
      },
      comment: {
        type: String,
        required: true,
      },
      placeholder: {
        type: String,
        default: '优质评论将会被优先展示哦~',
      },
      focus: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      content(val) {
        this.$emit('update:comment', val);
        this.disabled = val === '';
      },
      comment(val) {
        this.content = val;
      },
    },
    methods: {
      handleSendComment() {
        if (validator.isEmpty(this.content)) {
          this.$toast('请填写内容');
          return;
        }
        this.$emit('comment', this.content);
      },
      handleClickPageContent() {
        this.$emit('page-click');
      },
    },
    created() {
      this.content = this.comment;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .comment-bar {
    box-sizing: border-box;
    z-index: @z-index-large;
    height: @tabbar-comment-height;
    padding: @size-small +  @size-extra-small  / 2 @size-base;
    background-color: @color-white;
    + .page-content {
      padding-bottom: @tabbar-comment-height;
    }
  }

  .comment-form {
    flex: 1;
  }
</style>
